export interface DigizuiteFormat {
    id: number;
    width: number;
}

export const digizuiteFormats: DigizuiteFormat[] = [
    { id: 50382, width: 1500 },
    { id: 50383, width: 700 },
    { id: 50384, width: 500 },
    { id: 50385, width: 300 },
    { id: 50386, width: 200 },
];

export function getDigizuiteImageSrcAndSrcSet(
    propsSrc: string,
    clientWidth: number,
    tolerance: number = 10
) {
    const decodedSrc = decodeURIComponent(propsSrc);

    if (decodedSrc.includes("{formatid}")) {
        const srcSet = digizuiteFormats
            .map((format) => {
                const url = decodedSrc.replace("{formatid}", format.id.toString());
                return `${url} ${format.width}w`;
            })
            .join(", ");

        // Find det største format hvor format.width <= clientWidth
        let finalFormat = digizuiteFormats[digizuiteFormats.length - 1]; // fallback til største

        for (let i = digizuiteFormats.length - 1; i >= 0; i--) {
            const format = digizuiteFormats[i];
            if (clientWidth >= format.width) {
                finalFormat = format;
                break;
            }
        }

        const fallbackSrc = decodedSrc.replace("{formatid}", finalFormat.id.toString());
        return { src: fallbackSrc, srcSet };
    }

    return { src: decodedSrc, srcSet: "" }; // In case the formatid is not found
}
